import React, { useMemo } from "react";
import { Paper, Typography, Button, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    wrap: {
        display: "flex",
        flexWrap: "wrap",
        "& > *": { margin: 4 },
    },
}));

export default function PuntosControlButtons({
    puntosControl,
    selectedPuntoControl,
    onChange,
}) {
    const classes = useStyles();

    const buttons = useMemo(() => buildPcButtons(puntosControl), [puntosControl]);

    if (!buttons.length) return null;

    return (
        <Paper style={{ padding: 10, margin: 10 }}>
            <Typography variant="subtitle1" style={{ marginBottom: 8 }}>
                Punto de control
            </Typography>

            <Box className={classes.wrap}>
                {buttons.map((b) => {
                    const active = b.pcKey === selectedPuntoControl;
                    return (
                        <Button
                            key={b.pcKey} // 👈 clave real kPC_0
                            variant={active ? "contained" : "outlined"}
                            color={active ? "primary" : "default"}
                            size="small"
                            onClick={() => onChange(b.pcKey)}
                            style={{ textTransform: "none" }}
                        >
                            {b.label} {/* 👈 texto correcto */}
                        </Button>
                    );
                })}
            </Box>
        </Paper>
    );
}

function buildPcButtons(puntosControlObj) {
    if (!puntosControlObj || typeof puntosControlObj !== "object") return [];

    return Object.entries(puntosControlObj)
        .map(([pcKey, pc]) => {
            const order =
                typeof pc?.kNroPunto === "number"
                    ? pc.kNroPunto
                    : Number.isFinite(Number(pc?.kNroPunto))
                        ? Number(pc.kNroPunto)
                        : 999;

            // Tomamos modalidad_1/lap_1 como referencia para KM/desc (si existe)
            const modalidad1 = pc?.modalidadesPuntoDeControl?.modalidad_1;
            const lap1 = modalidad1?.laps?.lap_1;

            const baseLabel = pc?.descripcionFinalPunto || lap1?.descripcionPunto || pcKey;
            const km = lap1?.kilometro;

            const label =
                km !== undefined && km !== null
                    ? `${baseLabel} (KM ${km})`
                    : baseLabel;

            return {
                pcKey,      // 👈 "kPC_0"
                label,      // 👈 "Meta del evento (KM 80)" etc
                order,
            };
        })
        .sort((a, b) => a.order - b.order);
}
